import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Reason } from '../models/Reason';
import { environment } from '../../environments/environment';

@Injectable()
export default class ReasonService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    if (token) {
      return new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
    }
    return new HttpHeaders();
  }

  getReasons(): Observable<Reason[]> {
    return this.http.get<Reason[]>(this.baseUrl + 'Reasons', {
      headers: this.getHeaders(),
    });
  }
}
